import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { ContextItem } from "../../../../types";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";

export const getBackgroundChecksRequirementName = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  backgroundChecksRequest: IBackgroundCheckRequestResponse | undefined
): string => {
  return requirement.name || backgroundChecksRequest?.settings?.title || "--";
};
